import { render, staticRenderFns } from "./Esports.vue?vue&type=template&id=154af225&scoped=true"
import script from "./Esports.vue?vue&type=script&lang=js"
export * from "./Esports.vue?vue&type=script&lang=js"
import style0 from "./Esports.vue?vue&type=style&index=0&id=154af225&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154af225",
  null
  
)

export default component.exports